export default __webpack_public_path__ + "static/media/data-driven-maintenance.55c6f66f.svg";